import type {
  TicketCategoryDetailsDto,
  TicketCategoryRequest,
  UserRoleDto,
  UserRoleRepairCategoryPermissionsDto,
} from "@/api/types";
import { createFormPermissions, toPermissionsRequest } from "@/helpers/permissions";

import { DAYS_VARIANTS, type TicketCategoryDetailsFormValues } from "./TicketCategoryForm";

export function getTicketCategoryFormValues(
  roles: UserRoleDto[],
  defaultPermissions: UserRoleRepairCategoryPermissionsDto[],
  ticketCategory?: TicketCategoryDetailsDto,
): TicketCategoryDetailsFormValues {
  return {
    type: ticketCategory?.type || "single",
    name: ticketCategory?.name || "",
    defaultAssignee: ticketCategory?.defaultAssignee,
    notificationType: ticketCategory?.notificationType || "canBeCollective",
    closeAfterInactiveDayAmount: ticketCategory
      ? (String(ticketCategory.closeAfterInactiveDayAmount) as (typeof DAYS_VARIANTS)[number])
      : DAYS_VARIANTS[4],
    enabled: !ticketCategory?.disabled,
    audience: ticketCategory?.audience || [],
    permissions: createFormPermissions(roles, defaultPermissions, ticketCategory?.permissions),
    reopenPolicy: ticketCategory?.reopenPolicy || "unlimited",
    treeVveEnabled: ticketCategory?.treeVveEnabled || false,
    treeOverrideExternalCode: ticketCategory?.treeOverrideExternalCode || "",
    requirePhoneNumber: ticketCategory?.requirePhoneNumber ? "mandatory" : "notRequired",
    dicoEnabled: ticketCategory?.dicoEnabled,
    requireImages: ticketCategory?.requireImages ? "mandatory" : "notRequired",
  };
}

export function mapTicketCategoryFormToRequest(formData: TicketCategoryDetailsFormValues): TicketCategoryRequest {
  return {
    type: formData.type,
    audience: formData.audience,
    name: formData.name,
    translations: [],
    defaultAssigneeId: formData.defaultAssignee?.id,
    disabled: !formData.enabled,
    notificationType: formData.notificationType,
    closeAfterInactiveDayAmount:
      formData.closeAfterInactiveDayAmount === "0" ? undefined : Number(formData.closeAfterInactiveDayAmount),
    permissions: toPermissionsRequest(formData.permissions),
    reopenPolicy: formData.reopenPolicy,
    treeVveEnabled: formData.treeVveEnabled || false,
    treeOverrideExternalCode: formData.treeOverrideExternalCode || undefined,
    requirePhoneNumber: formData.requirePhoneNumber === "mandatory",
    dicoEnabled: formData.dicoEnabled || false,
    requireImages: formData.requireImages === "mandatory",
  };
}
